var _path, _path2, _path3, _line, _line2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 130,
    viewBox: "0 0 176 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.165 102.475C101.036 114.21 38.9792 111.708 33.4817 98.5271C28.0241 85.4416 70.06 69.4348 102.83 59.9312C142.304 48.483 172.252 42.5054 175 51.0178",
    stroke: "#FF97B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45288 62C-3.10673 49.9077 35 21 135.5 7",
    stroke: "#FF97B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 45C140 74.5 95 130 95 130C95 130 50 74.5 50 45C50 20.1472 70.1472 0 95 0C119.853 0 140 20.1472 140 45Z",
    fill: "#FF1E1D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.4142,
    y1: 28.5858,
    x2: 112.333,
    y2: 63.5047,
    stroke: "#005B4B",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 77.6668,
    y1: 63.5047,
    x2: 112.586,
    y2: 28.5858,
    stroke: "#005B4B",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.958 51C176.614 61.6168 129.438 68.1088 102.19 71.1691C74.9416 74.2293 8.95989 78.3501 1 62.0859",
    stroke: "#FF97B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressNotFound);
export default __webpack_public_path__ + "static/media/address_not_found.2c1a0872857da27eadf746188ed4e087.svg";
export { ForwardRef as ReactComponent };